(function () {
  // Run only on Store Locator map when Google Maps is the selected provider.
  const map = document.getElementById('map');
  if (!map || window.SDG?.Data?.mapProvider !== 'google_maps') return;

  // Default behavior: hide all default controls unless explicitly disabled in settings.
  let disableDefaultUI = true;
  try {
    // `data-google-control` carries section settings as JSON.
    const settings = JSON.parse(map.dataset.googleControl || '{}');
    disableDefaultUI = settings.google_disable_default_ui !== false && settings.google_disable_default_ui !== 'false';
  } catch (error) {
    // Keep safe default if JSON is malformed.
    disableDefaultUI = true;
  }

  // Patch importLibrary once so map-page.js can stay untouched.
  const maps = window.google?.maps;
  if (!maps?.importLibrary || maps.importLibrary.__cosmonetPatched) return;

  const importLibrary = maps.importLibrary.bind(maps);
  maps.importLibrary = async (name, ...args) => {
    const library = await importLibrary(name, ...args);
    if (name !== 'maps' || !library?.Map) return library;

    const BaseMap = library.Map;
    return {
      ...library,
      // Inject disableDefaultUI while preserving any other map options.
      Map: function MapWithDisabledDefaultUI(container, options = {}) {
        return new BaseMap(container, { ...options, disableDefaultUI });
      },
    };
  };
  maps.importLibrary.__cosmonetPatched = true;
})();
